import { Badge, Flex } from '@percent/lemonade'

type BadgeListProps = {
  items: string[]
}

export function BadgeList({ items }: BadgeListProps) {
  return (
    <Flex gap={2} wrap="wrap">
      {items.map(item => (
        <Badge key={item} variant="default">
          {item}
        </Badge>
      ))}
    </Flex>
  )
}
